export default __webpack_public_path__ + "static/media/pricing-lines-top.37411f8a.svg";